// extracted by mini-css-extract-plugin
module.exports = {"button":"C_bj","confirmation":"C_bQ","show":"C_bR"};